import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus, faUsers } from "@fortawesome/free-solid-svg-icons";

import "./Ready_To_Start.css";
import { useNavigate } from "react-router-dom";
import Common_Button from "../../Common_Components/common_button/Common_Button";

const ReadyToStart = ({
  title = "Ready to Start Your Journey?",
  description = "Join thousands of professionals who have successfully placed jobs globally through us.",
  buttonText = "Apply Now",
  buttonIcon = faUsers,
  navigateTo = "/new/apply_now",
}) => {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate(navigateTo);
  };
  const handleApplyNow = () => {
    navigate("/new/apply_now");
  };

  return (
    <section className="ready_start_section">
      <div className="container">
        <div className="ready_start_content">
          <h2 className="ready_start_title">{title}</h2>

          <p className="ready_start_text">{description}</p>

          <Common_Button
            type="button"
            text="Apply Now"
            icon={faUserPlus}
            className="application_submit_btn mt-4"
            onClick={handleApplyNow}
          />
        </div>
      </div>
    </section>
  );
};

export default ReadyToStart;
